import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLatestScraperRun, ScrapedTeamMember } from '../../redux/scraper/scraperSlice';
import { RootState, AppDispatch } from '../../redux';

const useLatestScraperRun = (practiceId: string, platform: string = 'simple_practice') => {
  const dispatch = useDispatch<AppDispatch>();

  const latestScraperRun = useSelector((state: RootState) => state.scraper.latestScraperRun);
  const run = latestScraperRun?.data || null;
  const loading = latestScraperRun?.loading || false;
  const error = latestScraperRun?.error || null;
  const members: ScrapedTeamMember[] = run?.scraperResult || [];

  const refetch = useCallback(() => {
    if (practiceId) {
      return dispatch(fetchLatestScraperRun({ practiceId, platform }));
    }
    return Promise.resolve(null);
  }, [dispatch, practiceId, platform]);

  useEffect(() => {
    if (practiceId) {
      dispatch(fetchLatestScraperRun({ practiceId, platform }));
    }
  }, [dispatch, practiceId, platform]);

  return {
    run,
    members,
    loading,
    error,
    refetch
  };
};

export { useLatestScraperRun };
